let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cirDO")).then(() => parcelRequire('fsocN'));